<div class="education">
    <h2 class="mat-display-2">Anmeldeformular für Administratoren</h2>
   
    <div class="form">
        <mat-card>
            <mat-card-content>
                <!-- <mat-card-title class="mat-display-1">
                    <span>Anmeldung</span>
                </mat-card-title> -->
                <div class="new-form">
                    <form [formGroup]="loginForm" (ngSubmit)="submitForm()">
                        <div class="mb-2">  
                            <div class="title1">
                                <span class="projName">Benutzername</span>
                                <div class="subtitle1">
                                    <input type="text" class="inputTitle" formControlName="username" label="Ihr Nutzername hier"
                                        placeholder="Benutzername">
                                </div>
                            </div>
                            <span class="note">Benutzername</span>
                        </div>
                        <div class="mb-2">  
                            <div class="title1">
                                <span class="projName">Passwort</span>
                                <div class="subtitle1">
                                    <input type="password" class="inputTitle" formControlName="password" label="Ihr Passwort hier"
                                        placeholder="Passwort">
                                </div>
                            </div>
                            <span class="note">Passwort</span>
                        </div>
                        <!-- <div>
                            <mat-form-field>
                                <mat-label>Benutzername</mat-label>
                                <input matInput formControlName="username" placeholder="Ihr Nutzername hier">
                                <mat-hint align="end">benutzername</mat-hint>
                            </mat-form-field>
                        </div> -->
                        <!-- <div>
                            <mat-form-field>
                                <mat-label>Passwort</mat-label>
                                <input type="password" matInput formControlName="password" placeholder="Ihr Passwort hier">
                                <mat-hint align="end">passwort</mat-hint>
                            </mat-form-field>
                        </div> -->
        
                        <mat-card-actions>
                            <button mat-raised-button>
                                Anmelden
                            </button>
                        </mat-card-actions>
                    </form>
                </div>
                
            </mat-card-content>
        </mat-card>
    </div>
</div>
